import ACTIONS from './BreadcrumbActions';

const initialState = {
    parent: { url: '', text: ''},
    list: { url: '', text: ''},
    service: { url: '', text: ''},
    source: { url: '', text: ''},
};

/**
 * Reducer to store user, user rights and
 * related information in the state.
 */
const breadcrumbReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Types.SET_BREADCRUMB: {
            return { ...state, ...action.payload}
        }

        default: {
            return {
                ...state
            }
        }
    }
};

export default breadcrumbReducer;
